import * as React from "react";
import { FormattedMessage } from "react-intl";
import { IconWrapper } from "common/icons";
import PACKS from "common/icons/packs";
import NumberFormatter from "@vingle/wtf-sdk/components/numberFormatter";
import OutlineButton from "app/common/components/featureButton/preset/outlineButton";
import { useIntl } from "app/common/intl/helpers";
import OverlayTooltip from "common/components/overlayTooltip";

const styles = require("./comment.scss");

interface IProps {
  commentCount: number;
  width: number;
  height: number;
  onClick?: () => void;
}

const CommentButton: React.FC<IProps> = ({
  width,
  height,
  onClick,
  commentCount,
}) => {
  const intl = useIntl();
  const [hoverState, setHoverState] = React.useState(false);
  const handleHover = React.useCallback(setHoverState, []);
  const changeableIcon = hoverState
    ? PACKS.ENGAGE.COMMENT_HOVER
    : PACKS.ENGAGE.COMMENT_NORMAL;

  return (
    <OverlayTooltip
      position="right"
      tooltipContent={<FormattedMessage tagName="span" id="comment" />}
    >
      <OutlineButton
        title={intl.formatMessage({ id: "comment" })}
        width={width}
        height={height}
        onClick={onClick}
        onHover={handleHover}
      >
        <span className={styles.iconWrapper}>
          <IconWrapper
            tagName="span"
            icon={changeableIcon}
            className={styles.icon}
          />
        </span>

        {Boolean(commentCount) && (
          <span className={styles.engageCount}>
            <NumberFormatter num={commentCount} digits={0} />
          </span>
        )}
      </OutlineButton>
    </OverlayTooltip>
  );
};

export default CommentButton;
